import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";

export interface HubTab {
  id: string;
  label: string;
}

interface HubTabsProps {
  tabs: HubTab[];
  activeTab: string;
  onChangeTab: (tabId: string) => void;
}

export function HubTabs({ tabs, activeTab, onChangeTab }: HubTabsProps) {
  return (
    <Tabs value={activeTab} onValueChange={onChangeTab} className="w-full">
      <TabsList className="h-auto w-full justify-start gap-6 border-b-2 border-gray-200 bg-transparent p-0">
        {tabs.map((tab) => (
          <TabsTrigger
            key={tab.id}
            value={tab.id}
            className={cn(
              "relative h-auto min-w-[60px] rounded-none border-b-2 border-transparent bg-transparent px-0 pb-2 text-base font-medium text-gray-500 data-[state=active]:bg-transparent data-[state=active]:text-black data-[state=active]:shadow-none data-[state=active]:after:absolute data-[state=active]:after:bottom-[-4px] data-[state=active]:after:left-0 data-[state=active]:after:right-0 data-[state=active]:after:z-10 data-[state=active]:after:h-[2px] data-[state=active]:after:bg-black data-[state=active]:after:content-['']",
            )}
          >
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
